import React from "react";
// import adminpanelimg from "../Images/admin panel.jpg";
import adminpanelimg from "../Images/administation.png";
import { NavLink } from "react-router-dom";
import './AdminPanel.css'

const AdminPanel = () => {
  const auth = localStorage.getItem("user");
  return (
    <div className="admin-panel-avcom-component">
      <div className="admin-panel-image-container">
        <img src={adminpanelimg} alt="xxx" />
      </div>
      {/* <div className="text-of-home-page">*/}
        {/* <div className="navigation-of-admin-panel">
          {" "}
          <NavLink className="avcom-navlink-of-admin-panel" to="/add-blog">
            Add-Blog
          </NavLink>{" "}
          {"  "}
          <NavLink className="avcom-navlink-of-admin-panel" to="/about-us">
            Form-Data
          </NavLink>
        </div> */}
      {/* </div>  */}



      <div className="welcome-msg-for-admin-panel-container">

      <div className="text-of-home-page">

        <p>Welcome to Admin Panel</p>
        <p style={{fontSize:'1rem', color:'#b01010'}}>Welcome Mr.  {JSON.parse(auth).name}</p>
        
      </div>
      <br /><br />  
      <div className="navigation-of-admin-panel">
          {" "}
          <NavLink className="avcom-navlink-of-admin-panel" to="/add-blog">
            Add-Blog
          </NavLink>{" "}
          {"  "}
          <NavLink className="avcom-navlink-of-admin-panel" to="/about-us">
            Form-Data
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default AdminPanel;
